import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const handleGoogle = () => {
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#EFE7D6]">
      <div className="hidden lg:block relative bg-[#1A362B]">
        <img
          src="https://images.pexels.com/photos/36534594/pexels-photo-36534594.jpeg"
          alt=""
          className="absolute inset-0 w-full h-full object-cover mix-blend-luminosity opacity-80"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#0e2419]/70" />
        <div className="absolute top-10 left-10 label-caps text-[#E8C170]">Shree Ram Pharma · Est. 1998</div>
        <div className="absolute bottom-14 left-10 right-10 text-[#EFE7D6]">
          <h2 className="font-serif-display text-4xl italic">&ldquo;Trust, bottled and delivered.&rdquo;</h2>
          <p className="mt-4 text-stone-300 text-sm max-w-sm">A quick sign-in with Google keeps your orders, addresses and history in one safe place.</p>
        </div>
      </div>
      <div className="flex flex-col justify-center px-8 sm:px-16 py-12 relative">
        <Link to="/" className="absolute top-8 left-8 flex items-center gap-2 text-sm text-stone-600 hover:text-[#1A362B] transition-colors" data-testid="back-home">
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>
        <div className="max-w-md w-full mx-auto">
          <div className="label-caps text-[#D96C4A] mb-4">Welcome</div>
          <h1 className="font-serif-display text-4xl lg:text-5xl text-[#1A362B] tracking-tight">Sign in to continue</h1>
          <p className="mt-4 text-stone-600">Use your Google account to shop, track deliveries and (if you&apos;re an owner) manage the pharmacy.</p>
          <Button
            onClick={handleGoogle}
            className="mt-10 w-full h-14 rounded-full bg-white hover:bg-stone-100 text-[#1C1917] border border-stone-300 flex items-center gap-3 justify-center text-base active:scale-[0.98] transition-transform"
            data-testid="google-signin-button"
          >
            <svg width="20" height="20" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
            Continue with Google
          </Button>
          <p className="mt-8 text-xs text-stone-500 leading-relaxed">
            By continuing, you agree to our terms & pharmacy policies. We only use your name & email to link your orders.
          </p>
        </div>
      </div>
    </div>
  );
}
